import React from 'react';
import ReconciliationCenter from './ReconciliationCenter';

export default function ReconciliationProduction() {
	return <ReconciliationCenter domain="Production" />;
}
